import BandTag from "./BandTag";
import GrowthSection from "./GrowthSection";

const StatRow = ({ label, referred, everyoneElse, suffix = "%", t }) => {
  // A hidden figure says why on hover (sc-46067).
  const cell = (value) =>
    value == null ? (
      <span title={t("growth.smallSample")}>—</span>
    ) : (
      `${value}${suffix}`
    );
  return (
    <tr>
      <td>{label}</td>
      <td>{cell(referred)}</td>
      <td>{cell(everyoneElse)}</td>
    </tr>
  );
};

/**
 * Requirements §6.3: referred-vs-everyone-else comparison, the framing that
 * justifies the referral reward budget. Correlational, not causal — someone
 * referred by a friend already has a training partner, which may be what
 * makes them stay, not the reward — so the caveat travels with the table.
 * All-time, hence the snapshot tag: the referral link is a property of the
 * person, not of the period.
 */
const GrowthReferrals = ({ data, t }) => {
  if (!data) return null;
  const { referred = {}, everyoneElse = {}, sampleSizes = {} } = data;
  return (
    <GrowthSection
      title={t("growth.referrals.title")}
      subtitle={t("growth.referrals.subtitle")}
    >
      <section className="incomes-container growth-card">
        <header className="table-card__header">
          <h3>{t("growth.referrals.tableTitle")}</h3>
          {/* All-time, not a snapshot (sc-46067). */}
          <BandTag kind="snapshot" label={t("growth.referrals.allTime")} />
          <span className="table-card__subtitle">
            {t("growth.referrals.sampleSizes", {
              referred: sampleSizes.referred ?? 0,
              everyoneElse: sampleSizes.everyoneElse ?? 0,
            })}
          </span>
        </header>
        {/* biome-ignore lint/a11y/useValidAriaRole: report-table used for structure */}
        <table role="report-table">
          <thead>
            <tr>
              <th />
              <th>{t("growth.referrals.referred")}</th>
              <th>{t("growth.referrals.everyoneElse")}</th>
            </tr>
          </thead>
          <tbody>
            <StatRow
              t={t}
              label={t("growth.referrals.trialConversion")}
              referred={referred.trialConversionRate}
              everyoneElse={everyoneElse.trialConversionRate}
            />
            <StatRow
              t={t}
              label={t("growth.referrals.reachedThree")}
              referred={referred.shareReachingThreeWorkouts}
              everyoneElse={everyoneElse.shareReachingThreeWorkouts}
            />
            <StatRow
              t={t}
              label={t("growth.referrals.churn90")}
              referred={referred.churn90Day}
              everyoneElse={everyoneElse.churn90Day}
            />
            <StatRow
              t={t}
              label={t("growth.referrals.avgLength")}
              referred={referred.avgSubscriptionLengthDays}
              everyoneElse={everyoneElse.avgSubscriptionLengthDays}
              suffix={` ${t("growth.referrals.days")}`}
            />
          </tbody>
        </table>
        <p className="growth-card__footnote">{t("growth.correlationalNote")}</p>
      </section>
    </GrowthSection>
  );
};

export default GrowthReferrals;
